export class Activity {
    type: string;
    date: string;
    description: string;
    url: string;
    ref: string;
    iconStyle: string;
    iconAlt: string;
    priority: string;
    // below used only for last login list
    count: number;
    updatedBy: string;
}